/* loaded by smart-asset */
export default require("./stripe~e7bf7d8afb1b37b6ff9601affd9504a6d6592e36.svg")